import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  public companyName: string;
  public showCompnayName = false;

  ngOnInit(): void {
    // Check if default page
    const pageUrl = window.location.pathname;
    if (pageUrl.toString() == '/') {
      this.showCompnayName = false;
    } else {
      this.showCompnayName = true;
    }
  }

  addCompanyName(companyName) {
    this.companyName = companyName;
  }
}
